import { Skeleton, Stack } from '@mui/material';
import { Component } from 'react';
import DashLabel from './DashLabel';
import { MdOutlineTimer, MdPhoneAndroid } from 'react-icons/md';
import { httpGet } from '../util/http';
import moment from 'moment';

export default class InventStatus extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            stats: {
                colets: 0
            }
        }
    }

    componentDidMount() {
        this.refresh();

        this.counter = setInterval(() => {
            this.setState({});
        }, 1000);

        this.timer = setInterval(() => {
            this.refresh();
        }, 30000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        clearInterval(this.counter);
    }

    refresh() {
        httpGet('/statistics/dep/' + this.props.deposito?.id,
            stats => {
                //console.log(stats)
                this.setState({
                    stats,
                    loading: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    convertTime(sec) {
        let hours = Math.floor(sec / 3600);
        (hours >= 1) ? sec = sec - (hours * 3600) : hours = '00';
        let min = Math.floor(sec / 60);
        (min >= 1) ? sec = sec - (min * 60) : min = '00';
        (sec < 1) ? sec = '00' : void 0;

        (min.toString().length == 1) ? min = '0' + min : void 0;
        (sec.toString().length == 1) ? sec = '0' + sec : void 0;

        return hours + ':' + min + ':' + sec;
    }

    render() {
        let time = moment().diff(moment(this.state.stats?.created_at), 'seconds');
        time = this.convertTime(time);
        return (
            <>
                {this.state.loading ? <Skeleton height={94} variant="rounded" /> :
                    <Stack padding={2} borderRadius={2} direction="row" gap={1} bgcolor="mariano.secondary">
                        <Stack gap={4} flex={1}>
                            <Stack flex={1} direction="row">
                                <DashLabel icon={MdOutlineTimer} title="Duração" subtitle={this.state.stats?.created_at ? time : '-'} />
                                <DashLabel icon={MdPhoneAndroid} title="Em operação" subtitle={this.state.stats?.colets + ' colets.'} />
                            </Stack>
                        </Stack>
                    </Stack>
                }
            </>
        );
    }
}